import { css } from 'styled-components';
import siteSettings from '../siteSettings.json';

export default css`
	html {
		background-color: white;
		padding: 0px;
		margin: 0px;
		overscroll-behavior: none;
		font-family: ${siteSettings.fontFamily};
		color: black;
	}
	body {
		padding: 0px;
		margin: 0px;
		overscroll-behavior: none;
	}
	* {
		box-sizing: border-box;
	}
	figure,
	img {
		padding: 0;
		margin: 0;
	}
	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		padding: 0;
		margin: 0;
	}
	a {
		color: inherit;
	}
`;
